import { type ClipboardScorePenaltyMultipliers } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";
import { CbhIcon, Text } from "@src/appV2/redesign/system/ui-components";

interface ActiveMultiplierInfoProps {
  multipliers: ClipboardScorePenaltyMultipliers;
}

export function getPenaltyMessage(multipliers: ActiveMultiplierInfoProps["multipliers"]): string {
  const areHighLatePenaltiesActive = multipliers.lateness.next > 1;
  const areHighCancellationPenaltiesActive = multipliers.cancellation.next > 1;

  if (!(areHighCancellationPenaltiesActive || areHighLatePenaltiesActive)) {
    return "Thanks to your strong track record, your next late arrival or cancellation will have a lower impact on your Clipboard Score.";
  }

  if (areHighLatePenaltiesActive && areHighCancellationPenaltiesActive) {
    return "Because of recent same-day cancellations and late arrivals, future penalties will be higher.";
  }

  return areHighLatePenaltiesActive
    ? "Future late arrivals will cost more points because of repeated late arrivals."
    : "Future cancellations will cost more points because of recent same-day cancellations. ";
}

export function ActiveMultiplierInfo({ multipliers }: ActiveMultiplierInfoProps) {
  const areHighLatePenaltiesActive = multipliers.lateness.next > 1;
  const areHighCancellationPenaltiesActive = multipliers.cancellation.next > 1;

  if (!(areHighCancellationPenaltiesActive || areHighLatePenaltiesActive)) {
    return null;
  }

  return (
    <>
      <CbhIcon type="clipboard-score-cancellation-colored" size="xLarge" />
      <Text>{getPenaltyMessage(multipliers)}</Text>
    </>
  );
}
